module.exports = __webpack_public_path__ + "assets/img/cog-icon-copy.9e74a978.svg";